import {useEffect, useState} from 'react';
import {isMobile} from "react-device-detect";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import "../../views/panel/components/statisticsChart/datePicker.scss";

/**
 Default Minimum Date object.
 @type {Object}
 */

const DefaultMinimumDate = {
    year: 1402,
    month: 4,
    day: 6
};

/**
 RangeDatePicker Component.
 @param {Object} handleDateRangeChange - Event handler for date range changes.
 @param {Date} minimumDate - The minimum date allowed to be selected.
 @param {Object} dateRange - The selected date range.
 @param {Date} maximumDate - The maximum date allowed to be selected.
 @returns {JSX.Element}
 */
const RangeDatePicker = ({handleDateRangeChange, minimumDate = DefaultMinimumDate, dateRange, maximumDate}) => {
    const [value, setValue] = useState(dateRange);

    useEffect(() => {
        setValue(dateRange);
    }, [dateRange])

    return (
        <div style={{direction: "ltr"}} className={isMobile ? "m-auto" : ""}>
            <DatePicker
                value={value}
                renderInput={({ref}) => (
                    <input
                        autoComplete={`off`}
                        value={(value?.from && value?.to) && `${value.from.year}/${value.from.month}/${value.from.day} تا ${value.to.year}/${value.to.month}/${value.to.day}`}
                        defaultValue={(value?.from && value?.to) && `${value.from.year}/${value.from.month}/${value.from.day} تا ${value.to.year}/${value.to.month}/${value.to.day}`}
                        ref={ref} name="dateRange" id="dateRange"
                        className='form-control w-100 text-center' style={{direction: "rtl"}}
                        placeholder="انتخاب بازه تاریخی"
                    />
                )}
                onChange={handleDateRangeChange}
                inputPlaceholder="انتخاب بازه تاریخی"
                //  formatInputText={formatInputValue}
                inputClassName="w-100 form-control form-control-picker"
                shouldHighlightWeekends
                calendarClassName="calendar-wrapper responsive-calendar"
                locale="fa"
                minimumDate={minimumDate}
                maximumDate={maximumDate}
            />
        </div>
    );
};

export default RangeDatePicker;
